import '../hue-colour-select.parent.component.scss';
import {hueColourSelectControllerBindings, HueColourSelectParentComponent} from "../hue-colour-select.parent.component";
import './multy-hue-colour-select.component.scss';

export class MultiHueColourSelectComponent extends HueColourSelectParentComponent {

    static instance: angular.IComponentOptions = {
        template: require('./multy-hue-colour-select.component.html'),
        controller: hueColourSelectControllerBindings(MultiHueColourSelectComponent),
        bindings: {
            title: '@',
            hues: '<',
            selectedColour: '=',
            selectedColourValueChange: '<',

        }
    };


}